import React, { useContext } from "react";
import LogicRuleMathExpComponent from "./LogicRuleMathExpComponent";
import { SB3RuleContext } from "../Rules/SB3RuleContext";
import LogicRulePreSubConditionComponent from "./LogicRulePreSubConditionComponent";
import { LOGICAL } from "./constants";

const LogicRuleSourceConditionComponent = () => {
    const {
      showTarget,
      toggleTarget,
      deleteLogicalCondtion,
      logicRule,
      addLogicalCondition,
      addMathCondition,
      addNestedMathCondition,
      addNestedLogicalCondition,
      updateOperator
    } = useContext(SB3RuleContext);
    return (
      <>
        <div>
          <label className="cart-title tw-m-2">Source</label>
          {
            logicRule?.rule?.source?.map((obj: any, objIndex: number) =>
              <>
                {
                  objIndex > 0 && (logicRule?.rule?.source[objIndex]?.condition?.length > 0) && (
                    <select data-testid="rulecomponents-logicrulesourceconditioncomponent-select-1"
                      value={logicRule?.rule?.source[objIndex]?.operator}
                      onChange={(e) => {
                        updateOperator(objIndex, 0, "outer", e?.target?.value)
                      }}
                      className="tw-w-[100px] tw-ml-2 tw-mt-2 tw-h-9 tw-px-2.5 tw-py-2 tw-bg-white tw-rounded tw-border tw-border-zinc-200 tw-gap-2.5">
                      {LOGICAL.map((op, opIndex) =>
                        <option key={opIndex} value={op}>
                        {op}
                        </option>
                      )}                 
                    </select>
                  )
                }
                <div className="rule-condition">
                  <>

                    {logicRule?.rule?.source[objIndex]?.condition?.length > 0 && <div className="left-root-rule-parenthesis" />}
                    <div>
                      {obj?.condition?.map((conditionObj: any, conditionObjIndex: number) =>
                        conditionObj?.type === "logicRule" ?
                          <>
                            {conditionObjIndex > 0 ? (
                              <select data-testid="rulecomponents-logicrulesourceconditioncomponent-select-2" key={conditionObjIndex}
                                value={logicRule?.rule?.source[objIndex]?.condition[conditionObjIndex]?.operator}
                                onChange={(e) => {
                                  updateOperator(objIndex, conditionObjIndex, "inner", e?.target?.value)
                                }}
                                className="tw-w-[100px] tw-ml-2 tw-mt-2 tw-h-9 tw-px-2.5 tw-py-2 tw-bg-white tw-rounded tw-border tw-border-zinc-200 tw-gap-2.5">
                                {LOGICAL.map((op, opIndex) => <option key={opIndex} value={op}>
                                  {op}
                                </option>)}              
                              </select>
                            ) : null}
                            <LogicRulePreSubConditionComponent
                              key={conditionObjIndex}
                              rootIndex={objIndex}
                              index={conditionObjIndex}
                              data={conditionObj}
                              deleteMethod={deleteLogicalCondtion}
                              type="source"
                            />
                          </> :
                          <>
                            {(conditionObjIndex > 0) &&
                              <select data-testid="rulecomponents-logicrulesourceconditioncomponent-select-3"
                                key={conditionObjIndex}
                                value={logicRule?.rule?.source[objIndex]?.condition[conditionObjIndex]?.operator}
                                onChange={(e) => {
                                  updateOperator(objIndex, conditionObjIndex, "inner", e?.target?.value)
                                }}
                                className="tw-w-[100px] tw-mt-2 tw-h-9 tw-px-2.5 tw-py-2 tw-bg-white tw-rounded tw-border tw-border-zinc-200 tw-gap-2.5">
                                {LOGICAL.map((op, opIndex) => <option key={opIndex} value={op}>
                                  {op}
                                </option>)}               
                              </select>
                            }
                            <LogicRuleMathExpComponent key={conditionObjIndex} rootIndex={objIndex}
                              index={conditionObjIndex} data={conditionObj} />
                          </>
                      )}
                    </div>
                    {(logicRule?.rule?.source[objIndex]?.condition?.length > 0) && <div className="tw-flex tw-row-start-2 tw-col-start-2
                    tw-col-end-8">
                      <button data-testid="rulecomponents-logicrulesourceconditioncomponent-button-4"
                        onClick={() => { addNestedLogicalCondition(objIndex) }}
                        className={`  tw-rounded tw-m-2  tw-bg-shades-of-grey-0 tw-text-primary tw-flex tw-flex-row tw-items-center tw-justify-center  tw-py-1 tw-px-2.5  tw-text-sm  tw-border-[1px] tw-border-solid tw-border-primary`}
                      >
                        Add Logical Condition
                      </button>
                      <button data-testid="rulecomponents-logicrulesourceconditioncomponent-button-5"
                        onClick={() => { addNestedMathCondition(objIndex) }}
                        className={`  tw-rounded tw-m-2  tw-bg-shades-of-grey-0 tw-text-primary tw-flex tw-flex-row tw-items-center tw-justify-center  tw-py-1 tw-px-2.5  tw-text-sm  tw-border-[1px] tw-border-solid tw-border-primary`}
                      >
                        Add Math Condition
                      </button>
                    </div>}
                    {logicRule?.rule?.source[objIndex]?.condition?.length > 0 && <div className="right-root-rule-parenthesis" />}
                  </>
          </div>
              </>
            )
          }

        </div>
        <div className="tw-flex">
          <button data-testid="rulecomponents-logicrulesourceconditioncomponent-button-6"
            onClick={() => {
              addLogicalCondition()
            }}
            className={`  tw-rounded tw-m-2  tw-bg-shades-of-grey-0 tw-text-primary tw-flex tw-flex-row tw-items-center tw-justify-center tw-py-1 tw-px-2.5  tw-text-sm  tw-border-[1px] tw-border-solid tw-border-primary`}
          >
            Add Logical Condition
          </button>
          <button data-testid="rulecomponents-logicrulesourceconditioncomponent-button-7"
            onClick={() => {
              addMathCondition()
            }}
            className={`  tw-rounded tw-m-2  tw-bg-shades-of-grey-0 tw-text-primary tw-flex tw-flex-row tw-items-center tw-justify-center tw-py-1 tw-px-2.5  tw-text-sm  tw-border-[1px] tw-border-solid tw-border-primary`}
          >
            Add Math Condition
          </button>
          <button data-testid="rulecomponents-logicrulesourceconditioncomponent-button-8"
            onClick={toggleTarget}
            className={`  tw-rounded tw-m-2  tw-bg-shades-of-grey-0  tw-flex tw-flex-row tw-items-center tw-justify-center tw-py-1 tw-px-2.5  tw-text-sm  tw-border-[1px] tw-border-solid tw-border-primary ${showTarget
              ? "tw-text-blue-400 tw-border-blue-400"
              : "tw-text-primary tw-border-primary"
              }`}
            disabled={showTarget}
          >
            Add Target
          </button>
        </div>
      </>
    );
  };

export default LogicRuleSourceConditionComponent;
